import React from 'react';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
const questions = ['What should I evaluate?', 'Which variables matter?', 'What decision am I trying to make?', 'What should I review before moving forward?'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-navy-950 px-4 py-16 sm:px-6 sm:py-20" data-id="element-169" data-mp="1snay9cmdwsmt">
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-72 bg-[radial-gradient(ellipse_at_bottom,rgba(201,162,75,0.16),transparent_65%)]" aria-hidden="true" data-id="element-170" data-mp="1eo1s75rw7ewk" />
      <div className="relative mx-auto flex w-full max-w-3xl flex-col items-center text-center" data-id="element-171" data-mp="14qx430ehl9d4">
        <h2 className="font-display text-[26px] font-bold leading-[1.15] text-white sm:text-4xl" data-id="element-172" data-mp="19of3o06m6c8g">
          Your next complex case doesn’t have to start with a blank page.
        </h2>
        <div className="gold-rule mt-5 h-px w-28" data-id="element-173" data-mp="342zjnzjzpjli" />

        <p className="mt-6 text-[15px] leading-relaxed text-slate-300 sm:text-lg" data-id="element-174" data-mp="342gdth7m6lnu">
          You don’t need another folder full of scattered information. You need a system that helps
          you organize what you already know.
        </p>

        <ul className="mt-7 grid w-full gap-2.5 sm:grid-cols-2" data-id="element-175" data-mp="b16vbu3x1dxp">
          {questions.map(question => <li key={question} className="rounded-xl border border-gold-500/25 bg-navy-900 px-4 py-3.5 text-[14px] font-bold uppercase tracking-wide text-gold-400" data-id="element-176" data-mp="6zbj3ukg5g55">
              {question}
            </li>)}
        </ul>

        <p className="mt-7 text-[15px] leading-relaxed text-slate-300" data-id="element-177" data-mp="3aiwpjafftolw">
          That’s what Dr. Karito created the Oclusion Clinical Playbook™ to help you do.
        </p>

        <div className="mt-8 w-full" data-id="element-178" data-mp="3jfx830ftsshf">
          <CtaButton label="Get the Oclusion Clinical Playbook™" subLabel="$27 one-time · Instant access · Lifetime access · 7-day guarantee" data-id="element-179" data-mp="13pu7n06ossz4" />
        </div>

        <div className="mt-6" data-id="element-180" data-mp="3sizf6iqgpoxn">
          <CountdownTimer data-id="element-181" data-mp="3sjshn7ie1s9z" />
        </div>
      </div>
    </section>;
}